import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountInvoicesQuery($filters: [Filter], $companyId: ID!) {
    Me {
      id
      Company(id: $companyId) {
        data: countInvoices(options: { filters: $filters })
      }
    }
  }
`
